
// This script is registered and enqueued in U4SM-adaptor\public\public.php

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.keyboardNav === "undefined") {
        jQuery.extend(sm.portal, { keyboardNav: {} });
    }

    jQuery.fn.modalTabbing = function () {
        var tabbing = function (jqSelector) {

            var inputs = jQuery(jqSelector).find(":tabbable");

            // Focus to first element in the container.
            inputs.eq(0).focus();

            jQuery(jqSelector).on('keydown', function (e) {
                var inputs = jQuery(jqSelector).find(":tabbable");
                if (e.which === 9) {
                    //redirect last tab to first input
                    if (!e.shiftKey) {
                        if (inputs[inputs.length - 1] === e.target) {
                            e.preventDefault();
                            inputs.first().focus();
                        }
                    }
                    //redirect first shift+tab to last input
                    else {
                        if (inputs[0] === e.target) {
                            e.preventDefault();
                            inputs.last().focus();
                        }
                    }
                }
            });
        };

        return this.each(function () {
            tabbing(this);
        });
    };

    // Wired up in function lightBox(title, ...) in sm.porta.ui...js
    function modalNav() {
        jQuery('.smModal').modalTabbing();
    }

    function keyboardControl(that) {
        if (!sm.portal.utility.isNullOrEmpty(that) && that.length > 0) {
            // add tab indices here if needed
            if (!that[0].hasAttribute('tabindex')) {
                that.attr('tabindex', '0');
            }

            that.on('keydown', function (event) {
                if (event.which == jQuery.ui.keyCode.SPACE || event.which == jQuery.ui.keyCode.ENTER) {
                    that.click();
                }
            });
        }
    }

    function aria() {

        //console.log('sm.keyboardnav.aria()');

        var homePage = jQuery('body.home .main-container .smallTopPad');

        // Main content area for all U4SM pages that pull in HTML via shortcodes.
        var innerPage = jQuery('.smContentArea');

        // Sections to target on shell pages.
        var loginHeader = jQuery('.loginHeader');
        var topheavy = jQuery('.topheavy'); // section for graphics link in login pages.
        var roleDialog = jQuery('.roleDialog');
        var sectionFull = jQuery('section.full').not('section.full.landing-hero').not('section.full.smLandingPageHeader');
        var smallTopPadContainer = jQuery('section.smallTopPad div.container');          // Target to get role of 'main' for the Continuing Education page and other pages with like structure.
        var smInvertedGrayContainer = jQuery('section.sm-inverted-grey div.container');// Target to get role of 'complementary' for the Continuing Education page and other pages with like structure.
        var smLandingPageHeaderSiblingRow = jQuery('section.full.smLandingPageHeader').siblings('div.row'); // Target to get role of complementary on Current Students page.

        // Only assign the variable this value if we are on the No Access page.  This var is passed into the mainContent array below.
        // Most U4SM pages will contain a Section tag with the 'smContentArea' class which will also gets assigned a role of main.  
        // We don't want two main roles on a page which may contain the .trsContent area and a HTML structure with 'section.full.smLandingPageHeader'.
        var noAccess = jQuery("title:contains('No Access')") ? jQuery('section.full.smLandingPageHeader').siblings('section') : null;

        // Non-semantic, interactive elements.
        var overrideRole = jQuery('.overrideRole'); //For removing any role from any DOM 
        var radioAsStdButton = jQuery('.field.inline input[type="radio"]').siblings('label');
        var requiredCourseExpander = jQuery('ul.reqCourseList > li');
        var inputAsloginButton = jQuery("input[name='login'][type='submit']"); // Login button on pages such as Advisor Login.
        //var liAsTabTypeOne = jQuery('ul.tabBar > li');       // HTML structure for tab set on Faculty 360.
        //var liAsTabTypeTwo = jQuery('div.tabSet > ul > li'); // HTML structure for tab set on Student 360 and My Schedule.
      
        var pagerWrap = jQuery('.pagerWrap');
        var pagerFirstPage = pagerWrap.find('span.icon.firstPage');
        var pagerPreviousPage = pagerWrap.find('span.icon.previousPage');
        var pagerNextPage = pagerWrap.find('span.icon.nextPage');
        var pagerLastPage = pagerWrap.find('span.icon.lastPage');
        var myAwards = jQuery('.myAwards ul.detailedList > li');

        // Group elements that are to be assigned like roles.
        var mainContent = [homePage, loginHeader, smallTopPadContainer, noAccess];
        var complementary = [sectionFull, smInvertedGrayContainer, smLandingPageHeaderSiblingRow, topheavy];
        var buttons = [radioAsStdButton, inputAsloginButton, pagerFirstPage, pagerPreviousPage, pagerNextPage, pagerLastPage];
        var tabs = [/*liAsTabTypeOne, liAsTabTypeTwo*/];
        var dialog = [roleDialog];
        var overrideRole= [overrideRole];

        function giveRole(elements, role) {
            jQuery(elements).each(function () {
                var that = jQuery(this);
                that.attr('role', role);
            });
        }

        giveRole(mainContent, 'main');
        giveRole(complementary, 'complementary');
        giveRole(buttons, 'button');
        //giveRole(tabs, 'tab');
        giveRole(dialog, 'dialog');
        giveRole(overrideRole, '');
        giveRole(myAwards, 'application');
        //giveState(detailedListExpander, 'detailsShowing');
        //giveState(liAsTabTypeOne, 'activeTab');
        //giveState(liAsTabTypeTwo, 'activeTab');

        // For ARIA implementation for expander on Required Courses, see trs.portal.vm.academic.studentdegreeaudit.widget-1.0.0.js, 
        

        // refactoring this into centralized location for all 'detailedList' toggling
        //function giveState(elem, activeClass) {
        //    // Check if element happens to be expanded on load and set initial state.
        //    elem.hasClass(activeClass) ? elem.attr('aria-expanded', 'true') : elem.attr('aria-expanded', 'false'); 

        //    elem.click(function () {
        //        var that = jQuery(this);
        //        that.hasClass(activeClass) ? that.attr('aria-expanded', 'true') : that.attr('aria-expanded', 'false');
        //    });
        //}
    }

    function ariaLabel() {
        var headerLinks = jQuery("#menu-main-menu.menu a")
        if (headerLinks!= null) {
            for (var index = 0; index < headerLinks.length; index++) {
                var ariaLabel = jQuery(headerLinks[index]).text();
                var subMenuLink = jQuery(headerLinks[index]);                    
                if (subMenuLink != null) 
                    subMenuLink.attr('aria-label', ariaLabel);
            }                
        }
    }

    function widget() {   
        var widget = jQuery('.flexWidget');
        var radioAsStdButton = widget.find('.field.inline input[type="radio"]').siblings('label');  // These are "buttons" for "My Grades View by: Session  Start Date".
        
        var appSectionItem = widget.find('li.appsecItem');
        var searchResultsItem = widget.find('.searchResultsItem');
        var recordedStatus = widget.find('.recordedStatus'); 
        var uploadDocumentIcon = widget.find('label.uploadBox'); // On Applicant Checklist page
        var tabbable = [radioAsStdButton, appSectionItem, searchResultsItem, recordedStatus, uploadDocumentIcon];
        var keyable = [appSectionItem, uploadDocumentIcon];
        var notLoggedIn = widget.find('form#AccountForm div[data-bind="visible: ShowNewAccount()"]');        
    
        jQuery(tabbable).each(function () {
            var that = jQuery(this);
            if (!sm.portal.utility.isNullEmptyOrNothing(that)) {
                that.attr('tabindex', '0');
            }
        });

        // Event handler for one-off items.  
        // The click hander for these elements resides in the Knockout library versues our functions that wrap a
        // "that.on('click, function....')" event in which case we place 'sm.keyboardnav.keyboardControl(that)' within those functions.
        jQuery('.reenrollmentSectionList').on('keydown','li.reenrollmentStepItem ', function (event){
            if (event.which == jQuery.ui.keyCode.SPACE || event.which == jQuery.ui.keyCode.ENTER) {
                event.preventDefault();
                event.stopPropagation();
                this.click();
            }
        });
	
	    radioAsStdButton.on('keydown', function (event) {
	        var that = jQuery(this);
            if (event.which == jQuery.ui.keyCode.SPACE || event.which == jQuery.ui.keyCode.ENTER) {
                // click the radio button to which the event is actually tied
                that.prev('input[type="radio"]').click();
            }
        });

        //For Apply Now page.  When user is not logged, tab should go to input box in login section, not appSectionItem.
        notLoggedIn.length ? widget.find('form#AccountForm input').first().focus() : null;
      
    }

    /**
     * giveContentFocus()
     * Needed in scenarios where desired tab order is outside of normal flow such as: 
     *  - Closing, Cancelling, or OK out of smModal and making tab focus go to main content instead of main menu.
     *  - Giving slide ups focus upon key event on sticky footer buttons (Registration).
     * 
     * @param string $elem Tag and/or class, or ID
     */
    function giveContentFocus(elem) { 
        var content = jQuery(elem);
        var firstTabbable = content.find(':tabbable').first().not(':hidden');
        firstTabbable.focus();
    }

    //// Helper Functions
    //function IsNullOrEmpty(value) {
    //    if (value == null || value == undefined || value.toString() == '' || (Array.isArray(value) && value.length == 0))
    //        return true;
    //    return false;
    //}

    // extend our namespace
    jQuery.extend(true, sm.portal.keyboardNav, {
        modalNav                :   modalNav,
        keyboardControl         :   keyboardControl,
        aria                    :   aria,
        ariaLabel               :   ariaLabel,
        widget                  :   widget,
        giveContentFocus        :   giveContentFocus
    });

})(jQuery);
